<template>
    <v-card class="bot-table mx-auto">
        <v-card-title>
            <slot name="bot-table-title"></slot>
            <!-- <div v-html="options.title"></div> -->
            <v-spacer></v-spacer>
            <v-text-field
                v-model="search"
                clearable
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
            ></v-text-field>
        </v-card-title>
        <v-data-table
            v-model="selected"
            :loading="spinning"
            :headers="options.headers"
            :show-select="options['show-select']"
            :single-select="options['single-select']"
            :item-key="options['item-key']"
            :items-per-page="options['items-per-page']"
            :items="dataSource"
            :custom-filter="botTableFilter"
            :search="search"
            class="elevation-1"
        >
            <!-- <template v-slot:[`item.ProductID`]="{ item }">
                    {{ item }}
                </template> -->
            <template
                v-slot:[`item.data-table-select`]="{ isSelected, select }"
            >
                <v-simple-checkbox
                    :value="isSelected"
                    :readonly="spinning"
                    :disabled="spinning"
                    @input="select"
                ></v-simple-checkbox>
            </template>
            <template v-slot:[`footer.prepend`]>
                <div v-if="options['show-select'] && selected.length">
                    <v-menu
                        title="Xóa"
                        transition="fab-transition"
                        offset-overflow
                        :nudge-width="200"
                        offset-x
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" color="error">
                                Xóa
                                <v-icon right> mdi-close-circle </v-icon>
                            </v-btn>
                        </template>
                        <v-card>
                            <v-card-title>Bạn có chắc?</v-card-title>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="success darken-1"
                                    text
                                    @click="handleRemoveItem"
                                >
                                    <v-icon left> mdi-check </v-icon>
                                    Confirm
                                </v-btn>
                                <v-btn color="pink" text>
                                    <v-icon left> mdi-close </v-icon>
                                    Cancel
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-menu>
                </div>
            </template>
            <template
                v-for="hd in options.headers"
                v-slot:[`item.${hd.value}`]="{ item }"
            >
                <div :key="hd.key" v-if="hd.type === `badge`">
                    <v-badge
                        :color="item[hd.data.color]"
                        :content="item[hd.data.content]"
                        :left="hd.props.left"
                    >
                        {{ item[hd.value] }}
                    </v-badge>
                </div>
                <span :key="hd.key" v-if="hd.type === `number`">
                    {{ item[hd.value] | fmn }}
                </span>
                <span :key="hd.key" v-if="hd.type === `link`">
                    <a
                        target="_blank"
                        :href="item[hd.value.href]"
                        :title="item[hd.value.title]"
                        >{{ item[hd.value.title] }}</a
                    >
                </span>
                <div
                    :key="hd.key"
                    v-if="hd.type === `truncate`"
                    class="truncate"
                >
                    {{ item[hd.value] }}
                </div>
                <span :key="hd.key" v-if="hd.type === 'slot'">
                    <slot
                        :name="`bot-table-header-${hd.value}`"
                        :item="item"
                    ></slot>
                </span>
                <v-menu
                    :key="hd.key"
                    v-if="hd.type === `delete`"
                    transition="fab-transition"
                    offset-overflow
                    :nudge-width="200"
                    offset-x
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" color="red">
                            mdi-close-circle-outline
                        </v-icon>
                    </template>
                    <v-card>
                        <v-card-title>Bạn có chắc?</v-card-title>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="success darken-1"
                                text
                                @click="$emit('deleteItem', item)"
                            >
                                <v-icon left> mdi-check </v-icon>
                                Confirm
                            </v-btn>
                            <v-btn color="pink" text>
                                <v-icon left> mdi-close </v-icon>
                                Cancel
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>
                <span :key="hd.key" v-if="hd.type === undefined">
                    {{ item[hd.value] }}
                </span>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
const cafe = {
    default: {
        key: "No",
    },
};
const df = cafe.default;

export default {
    name: "BotTable",

    props: {
        options: {
            type: Object,
            default: () => {
                return {
                    title: "This is the title",
                    headers: [],
                };
            },
        },
        dataSource: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            search: "",
            spinning: false,
            selected: [],
        };
    },

    mounted() {
        let { headers } = this.options;
        for (let [h, hd] of headers.entries()) {
            if (hd.type === "number") hd.align = "end";
            hd.key = `${h + 1}-${hd.value}`;
        }
    },

    watch: {
        value: {
            handler(data) {
                console.log("bot.table.handler", data.length);
            },
            deep: true,
        },
    },

    computed: {},

    methods: {
        loading(isLoading) {
            this.spinning = isLoading;
        },
        select(items) {
            if (!Array.isArray(items)) return;
            this.selected = items;
        },
        botTableFilter(__, queryText, item) {
            let isValid = false;
            queryText = this.$options.filters.tRemove.reg(queryText);
            for (let key of Object.keys(item)) {
                let value = item[key];
                if (!value) continue;
                if (typeof value !== "string") value = JSON.stringify(value);
                let reg = new RegExp(queryText, "gi");
                isValid = isValid || reg.test(value.toLowerCase());
                if (!isValid) continue;
                break;
            }

            return isValid;
        },
        handleRemoveItem() {
            if (!this.selected.length) return;
            let dataSource = [];
            let keys = [];
            let key = this.options["item-key"] || df.key;
            for (let item of this.selected) {
                let value = item[key];
                if (value === undefined) continue;
                keys.push(value);
            }
            for (let item of this.dataSource) {
                let value = item[key];
                if (keys.includes(value)) continue;
                dataSource.push(item);
            }
            console.log("handleUpdate.dataSource", dataSource);
            this.$emit("handleUpdate", { dataSource });
            this.selected = [];
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
.bot-table + div.text-center {
    margin-top: 20px;
}

.truncate {
    max-width: 50vw;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.bot-table .v-data-table-header {
    background-color: #4472c4;
}

.bot-table .theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>th {
    color: #FFF;
}

.bot-table tbody tr:nth-child(odd) {
    background-color: #d9e1f2;
}

.bot-table td:not(:last-child), .bot-table th:not(:last-child) {
    border-right: 1px solid #ccc;
}
</style>



// WEBPACK FOOTER //
// bot.table.vue